import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import thunk from 'redux-thunk'
import rootReducer from './reducers'
import storage from 'redux-persist/lib/storage/session'

const rootPersistConfig = {
  key: 'root',
  storage,
  blacklist: process.env.REACT_APP_STAGE === 'PROD' ? ['auth', 'app', 'styles'] : [],
}

const persistedReducer = persistReducer(rootPersistConfig, rootReducer)

const store = createStore(persistedReducer, {}, applyMiddleware(thunk))

const persister = persistStore(store)

export { store, persister }
